import * as st from './styles.module.scss';

interface Props {
  onClick?: () => void;
}

export const ActionsButton = ({ onClick }: Props): JSX.Element => {
  return (
    <button className={st.actions} onClick={onClick}>
      Действия
    </button>
  );
};
